import ApiClient from "@/libs/http-client";

const AuthService = {
  endpoints(route) {
    const url = {
      verifyAuth: "/api/auth/login",
      refreshToken: "/api/refresh",
      personalInfo: "/api/auth/me"

    };

    return url[route];
  },

  get(url, param) {
    return ApiClient.get(this.endpoints(url), param);
  },
  post(url, data, config = {}) {
    return ApiClient.post(this.endpoints(url), data, config);
  },
};

export default AuthService;
